import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { Globe, Workflow, Sparkles, ArrowUpRight } from 'lucide-react';
import { SectionHeading } from './ui-kit/SectionHeading';
import { FeatureCard } from './ui-kit/FeatureCard';
import { Reveal } from './ui-kit/Reveal';
import { Link } from 'react-router-dom';

const ICONS = [Globe, Workflow, Sparkles];

const Services = () => {
  const { t } = useLanguage();
  return (
    <section id="lisapalvelut" className="py-20 md:py-24 bg-surface-muted" data-testid="services-section">
      <div className="container-page">
        <SectionHeading
          eyebrow={t.services.eyebrow}
          title={t.services.title}
          lead={t.services.subtitle}
        />

        <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {t.services.items.map((item, i) => {
            const Icon = ICONS[i % ICONS.length];
            return (
              <Reveal key={item.title} delay={i * 60}>
                <FeatureCard className="h-full" data-testid={`service-card-${i}`}>
                  <div className="flex items-start justify-between gap-6">
                    <div>
                      <div className="inline-flex h-11 w-11 items-center justify-center rounded-input bg-brand-soft text-brand">
                        <Icon className="w-[19px] h-[19px]" strokeWidth={1.75} />
                      </div>
                      <h3 className="mt-6 text-h3 text-ink">{item.title}</h3>
                      <p className="mt-3 text-body text-ink-muted max-w-md">{item.description}</p>
                    </div>
                    <Link
                      to={item.href || '/palvelut'}
                      aria-label={`${item.title} – ${t.common.learnMore}`}
                      className="inline-flex h-9 w-9 items-center justify-center rounded-pill border border-line text-ink-muted hover:border-ink hover:text-ink transition-colors"
                    >
                      <ArrowUpRight className="w-4 h-4" />
                    </Link>
                  </div>
                </FeatureCard>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Services;
